import angular from "angular";
import {HeaderComponent} from "./header.component";

export default angular.module('slViz.header', [])
    .component('header', HeaderComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/header/index.js